import { render, staticRenderFns } from "./BatterySensorModule.vue?vue&type=template&id=265e6a49&scoped=true"
import script from "./BatterySensorModule.vue?vue&type=script&lang=js"
export * from "./BatterySensorModule.vue?vue&type=script&lang=js"
import style0 from "./BatterySensorModule.vue?vue&type=style&index=0&id=265e6a49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e6a49",
  null
  
)

export default component.exports